// extracted by mini-css-extract-plugin
export var quillEditor = "_mj-1";
export var variable = "_mj-0";